import React from "react";

const MouseMetricIcon = () => {
  return (
    <svg width="19" height="25" viewBox="0 0 19 25" xmlns="http://www.w3.org/2000/svg">
      <g fillRule="nonzero" fill="none">
        <path
          d="M15.9082 2.93c-.3771737-.40650236-.8084849-.75917614-1.2818-1.0481.6606822 1.07714946.9599315 2.33721314.8541 3.5964l-.88 11C14.3367295 19.5893922 11.7422172 21.9848638 8.62 22H6.38c-1.10291817-.0013317-2.18371724-.3094884-3.1215-.89C4.3481332 22.8971759 6.2868635 23.9911778 8.38 24h2.24c3.1223005-.0149206 5.7170179-2.4103348 5.9809-5.5215l.88-11c.1413621-1.67019666-.4298815-3.3223246-1.5727-4.5485z"
          className="icon icon__shade"
        />
        <path
          d="M11.5 0h-4C5.54654417.00008826 3.68198818.81644436 2.35692698 2.2517849S.36685376 5.61086278.5226 7.5581l.88 11C1.6935653 22.1959309 4.73055147 24.9998351 8.38 25h2.24c3.6495638-.0000085 6.6867255-2.8039542 6.9777-6.4419l.88-11c.1557504-1.94728924-.5093014-3.8710748-1.8344287-5.3064253C15.3181439.8163242 13.453508.00000453 11.5 0zm5.9809 7.4785l-.88 11C16.3370179 21.5896652 13.7423005 23.9850794 10.62 24H8.38c-3.12230048-.0149206-5.71701793-2.4103348-5.9809-5.5215l-.88-11c-.13353836-1.66912882.4364909-3.31812483 1.57232178-4.54845476C4.22725265 1.6997153 5.82553784.99999704 7.5 1h4c1.6744622-.00000296 3.2727473.6997153 4.4085782 1.93004524C17.0444091 4.16037517 17.6144384 5.80937118 17.4809 7.4785z"
          className="icon__line"
        />
        <path
          d="M9.5 3c-.27614237 0-.5.22385763-.5.5v2c0 .27614237.22385763.5.5.5.27614237 0 .5-.22385763.5-.5v-2c0-.27614237-.22385763-.5-.5-.5z"
          className="icon icon__line"
        />
      </g>
    </svg>
  );
};
export default MouseMetricIcon;
